import { match } from 'utils/pattern-match-util'
import { UserDataType } from 'iam/models/UserDataType'

/**
 * Formats the UserDataType enum to a user friendly string.
 */
export function formatUserDataType(userDataType: UserDataType): string {
  return match(userDataType, {
    [UserDataType.User]: () => 'Client',
    [UserDataType.Pro]: () => 'Pro',
    [UserDataType.Admin]: () => 'Admin',
    [UserDataType.CallAgent]: () => 'Call Agent',
  })
}
